import EvaluateResult from "../../../EvaluateResult"
import { DecisionReason } from "../../../../model/model"

export interface InAppMessageEligibilityEvaluateResult extends EvaluateResult {
  isEligible: boolean
}

class DefaultInAppMessageEligibilityEvaluateResult implements InAppMessageEligibilityEvaluateResult {
  constructor(readonly reason: DecisionReason, readonly isEligible: boolean) {}
}

// Merged with the interface above so `InAppMessageEligibilityEvaluateResult.eligible(...)` works as a value.
export const InAppMessageEligibilityEvaluateResult = {
  eligible(reason: DecisionReason): InAppMessageEligibilityEvaluateResult {
    return new DefaultInAppMessageEligibilityEvaluateResult(reason, true)
  },

  ineligible(reason: DecisionReason): InAppMessageEligibilityEvaluateResult {
    return new DefaultInAppMessageEligibilityEvaluateResult(reason, false)
  }
}
